import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'


const AdditionalItems = () => {
        const navigate = useNavigate();
    
    const [additionalItems, setAdditionalItems] = useState([]);
    const [form, setForm] = useState({});
    const [isEdit, setIsEdit] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const getAdditionalItems = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-additional-items`, {
            withCredentials: true
        })
            .then(res => {
                setAdditionalItems(res.data.additionalItems || []);
                setIsLoading(false);
            })
            .catch((error) =>{ setIsLoading(false); 
                      globalErrorHandler(error, navigate); 
                
                });
    };

    useEffect(() => {
        getAdditionalItems();
    }, []);

    const openAddModal = () => {
        setForm({});
        setIsEdit(false);
        setShowModal(true);
        setSelectedId(null);
    };

    const openEditModal = (ai) => {
        setForm({ name: ai.name, rate: ai.rate, description: ai.description });
        setIsEdit(true);
        setShowModal(true);
        setSelectedId(ai.id);
    };

   const validateAdditionalItemForm = () => {
  if (!form.name?.trim()) {
    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please enter a Phase name.'
    });
    return false;
  }

  if (form.rate === "" || form.rate === null || isNaN(form.rate)) {
    Swal.fire({
      icon: 'warning',
      title: 'Validation Error',
      text: 'Please enter a valid numeric rate.'
    });
    return false;
  }

  return true;
};
    const saveAdditionalItem = () => {
        if (!validateAdditionalItemForm()) return;

        axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/create-additional-item`, form, { withCredentials: true })
            .then(res => {
                if (res.data.status) {
                    Swal.fire('Success', 'Additional item added!', 'success');
                    setShowModal(false);
                    getAdditionalItems();
                }
            })
            .catch(err =>globalErrorHandler(err, navigate));
    };

    const updateAdditionalItem = () => {

        if (!validateAdditionalItemForm()) return;

        axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/update-additional-item`, { ...form, id: selectedId }, { withCredentials: true })
            .then(res => {
                if (res.data.status) {
                    Swal.fire('Success', 'Additional item updated!', 'success');
                    setShowModal(false);
                    getAdditionalItems();
                }
            })
                       .catch(err =>globalErrorHandler(err, navigate));

    };

    const deleteAdditionalItem = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will permanently delete the additional item.',
            icon: 'warning',
            showCancelButton: true
        }).then(result => {
            if (result.isConfirmed) {
                axios.post(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/delete-additional-item`, { id }, { withCredentials: true })
                    .then(res => {
                        if (res.data.status) {
                            Swal.fire('Deleted!', res.data.message, 'success');
                            getAdditionalItems();
                        }
                    })
            .catch(err =>globalErrorHandler(err, navigate));
            }
        });
    };

    return (
        <div className="container-fluid px-4 mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Additional Items</h3>
                <Button variant="success" onClick={openAddModal}>Add New Additional Item</Button>
            </div>
      <table className="table table-bordered table-hover shadow-sm">
                <thead className="table-success">
                    <tr>
                        <th>Name</th>
                        <th  >Description</th>
                        <th>Rate</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr><td colSpan="2">Loading...</td></tr>
                    ) : additionalItems.length === 0 ? (
                        <tr><td colSpan="2">No data found.</td></tr>
                    ) : (
                        additionalItems.map(ai => (
                            <tr key={ai.id}>
                                <td>{ai.name}</td>
                                <td >
                                    {ai.description?.length > 300 ? ai.description.slice(0, 300) + "..." : ai.description}
                                </td>
                                <td>${parseFloat(ai.rate).toFixed(2)}</td>

                                <td>
                                    <Button variant="info" className="me-2" onClick={() => openEditModal(ai)}>Edit</Button>
                                    <Button variant="danger" onClick={() => deleteAdditionalItem(ai.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{isEdit ? 'Edit AdditionalItem' : 'Add AdditionalItem'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Description</label>
                        <textarea className="form-control"
                            onChange={(e) => setForm({ ...form, description: e.target.value })}
                        >
                            {form.description}
                        </textarea>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Rate</label>
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            className="form-control"
                            value={form.rate}
                            onChange={(e) => setForm({ ...form, rate: e.target.value })}
                        />
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={isEdit ? updateAdditionalItem : saveAdditionalItem}>
                        {isEdit ? 'Update' : 'Save'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AdditionalItems;
